import { stagesBuilder, StagesModel } from "shared/models/Stages";
import { httpTrafficLights } from "../http/httpClient";

export const stagesService = () => {
  const getAll = async (
    page: number | null,
    page_size: number | null,
    sort: string | null,
    dir: string | null,
  ): Promise<StagesModel> => {
    const params = new URLSearchParams();
    if (page !== null) params.append('page', String(page));
    if (page_size !== null) params.append('page_size', String(page_size));
    if (sort !== null) params.append('sort', String(sort));
    if (dir !== null) params.append('sort_dir', String(dir));

    const res = await httpTrafficLights.get(`stages?${params.toString()}`);

    return {
      ...res,
      page: Number(res.page),
      page_size: Number(res.page_size),
      total: Number(res.total),
      rows: res.rows.map(stagesBuilder.fromBackEnd),
    };
  };

  return {
    getAll,
  };
};

